import * as React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {IncentiveTrip} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './QualifiedForIncentiveTripReportContent.style';

interface QualifiedForIncentiveTripReportContentProps {
  getTheme: (key: string) => string;
}

const QualifiedForIncentiveTripReportContent: React.FC<
  QualifiedForIncentiveTripReportContentProps
> = ({getTheme = noop}: QualifiedForIncentiveTripReportContentProps) => {
  const {tt} = useTranslation('reportCardContent.qualifiedForIncentiveTrip');

  const iconStyle = {
    ...styles.icon,
    color: getTheme('competency.textColor.color'),
  };

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <View style={styles.headerContainer}>
            <Icon
              name="circle-checkmark-filled"
              style={iconStyle}
              {...testProperties(
                IncentiveTrip.itQualifiedForIncentiveTripCheckbox,
              )}
            />
            {tt(
              'description',
              generateComponentCallback({
                component: (
                  <Text
                    style={styles.headerText}
                    variant="heading"
                    {...testProperties(IncentiveTrip.itTitle)}>
                    Qualified for the OPTA
                    <Text variant="small" style={styles.headerText}>
                      {'VIA '}
                    </Text>
                    Incentive Trip 2024.
                  </Text>
                ),
              }),
            )}
          </View>
        </Gutter>
      </View>
    </View>
  );
};

export default withHOC(
  withTheme,
  withCompetency,
)(QualifiedForIncentiveTripReportContent);
